import { withTranslation } from 'react-i18next';

import Accounts from './Accounts';

export default withTranslation()(Accounts);
